<template>
    <div class="digitboard p-2 px-3">
        <span class="digit-title">{{ title }}</span><br>
        <span class="digit-value">{{ symbol }}{{ value ? value : 0 }}</span>
    </div>
</template>

<script>
    export default {
        props : ["title", "color", "value", "symbol"]
    }
</script>

<style scoped>
.digitboard{
    width : 300px;
    border-radius: 10px 10px;
    background-color: #00377b;
    color: white;
}
.digit-title{
    font-size: 1.3rem;
    font-weight: bold;
}
.digit-value{
    font-size: 2.3rem;
    font-weight: bolder;
}

@media screen and (max-width: 999px){

    .digit-title{
        font-size: 0.85rem;
    }

    .digit-value{
        font-size: 1.5rem;
    }

}
</style>